<template>
  <div style="background: #f9f9f9">
    <!--    <img src="./print.svg" alt="" style="width: 100%;">-->

    <div class="printBanner">
      <div style="height: 170px">
        <div class="container">
          <el-row :gutter="30" style="padding-top: 50px">
            <el-col :span="12" :offset="6" class="bannerSearch">
              <el-input
                size="large"
                placeholder="请输入内容"
                v-model="input"
                class=""
                @keyup.native.enter="getShopperList"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="getShopperList"
                  type="primary"
                ></el-button>
              </el-input>
              <ul class="flex" style="font-size: 12px; color: #fff">
                <li style="margin: 15px; margin-left: 0px; cursor: pointer" @click="searchByKeyword(items)" v-for="(items, index) in keywords">{{ items }}</li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

    <div class="container">
      <section style="padding-bottom: 30px">
        <el-row :gutter="30">
          <el-col :span="6">
            <section class="leftCont">
              <el-card class="leftCard" shadow="never">
                <div slot="header" class="clearfix">
                  <span>推荐服务商</span>
                </div>
                <div>
                  <ul class="hotSell">
                    <li v-for="(items, index) in hotSells" :key="index" @click="getPrintServiceIndex(items.enterPriseId)">
                      <div class="mpBox">
                        <el-image
                          style="width: 66px; height: 30px; margin-right: 15px"
                          :src="items.storeLogo"
                          fit="fill"
						  v-if="items.storeLogo!=null && items.storeLogo!='' && items.storeLogo!=undefined" 
                        >
                        </el-image>
						<el-image v-else :src="require('@/assets/storeLogo.jpeg')"  style="width: 66px; height: 30px; margin-right: 15px"></el-image>
                        <div class="topServBoxInfo">
                          <h3 :title="items.enterPriseName">{{ items.enterPriseName }}</h3>
                          <p>
                            <el-rate
                              :value="items.valueL"
                              disabled
                              show-score
                              :score-template="items.num"
                              :colors="['#da251d', '#da251d', '#da251d']"
                            >
                            </el-rate>
                          </p>
                        </div>
                      </div>
                    </li>
                    <!-- 5 -->
                  </ul>
                </div>
              </el-card>
              <el-card class="leftCard" shadow="never">
                <div slot="header" class="clearfix">
                  <span>热门服务</span>
                </div>
                <div>
                  <ul class="hotSell">
                    <li v-for="(items, index) in hotSevers"
                        @click="getServiceDetails(items.uuid)"
                        :key="index">
                      <div class="mpBox">
                        <div
                          style="width: 64px; height: 64px; margin-right: 15px"
                        >
                          <el-image
                            style="
                              width: 66px;
                              height: 50px;
                              border-radius: 4px;
                            "
                            v-if="items.urlList.length > 0"
                            :src="items.urlList[0].urlPath"
                            fit="fill"
                          >
                          </el-image>
                        </div>
                        <div class="topServBoxInfo">
                          <h3 :title="items.serviceName">{{ items.serviceName }}</h3>
                          <p>{{ items.enterPriseName }}</p>
                        </div>
                      </div>
                    </li>
                    <!-- 5 -->
                  </ul>
                </div>
              </el-card>
            </section>
          </el-col>
          <el-col :span="18">
            <section style="margin: 30px 0">
              <!-- 当前位置 -->
              <div class="desTitle flex">
                <span>当前位置：</span>
                <!-- <span style="color: #777">我要打印 > 全部服务商</span> -->
				<el-breadcrumb separator=">">
				<el-breadcrumb-item :to="{ path: '/print' }">我要打印</el-breadcrumb-item>
				<el-breadcrumb-item >全部服务商</el-breadcrumb-item>
				</el-breadcrumb>
              </div>
              <div class="screen">
                <div class="screenMess flex">
                  <p class="screenMess_t">服务行业：</p>
                  <p
                    :class="
                      severmessIndex == index ? 'screenMess_m1' : 'screenMess_m'
                    "
                    v-for="(items, index) in serveList"
                    :key="index"
                    @click="getServerMess(index,items.uuid)"
                  >
                    {{ items.name }}
                  </p>
                </div>
                <div class="screenMess flex">
                  <p class="screenMess_t">
                    材&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;料：
                  </p>
                  <p
                    :class="
                      severmessIndex2 == index
                        ? 'screenMess_m1'
                        : 'screenMess_m'
                    "
                    v-for="(items, index) in serveList2"
                    :key="index"
                    @click="getServerMess2(index,items.uuid)"
                  >
                    {{ items.name }}
                  </p>
                </div>
                <div class="screenMess2 flex">
                  <p class="screenMess_t2">
                    地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;区：
                  </p>
                  <el-cascader
                    :props="{ checkStrictly: true }"
                    v-model="regionValue"
                    @change="handleChange"
                    :options="regionOptions"
                    placeholder="省/市/区"
                    style="width: 334px"
                    clearable
                  ></el-cascader>
                </div>
              </div>
              <div v-if="compDetailsList.length==0" style="text-align:center;margin-bottom:20px" >
                 <img src="../../assets/暂无搜索内容.jpg" alt="" style="width:200px">
              </div>
              <ul  v-if="compDetailsList.length!=0">
                <li
                  style="margin-bottom: 20px"
                  v-for="(items, index) in compDetailsList"
                  :key="index"
                >
                  <div style="background-color: #fff; padding: 25px 20px 30px">
                    <el-row :gutter="30" class="hotSellServ">
                      <el-col :span="10">
                        <div class="mpBox">
                          <img
                          style="
                              width: 66px;
                              height: 30px;
                              margin-right: 15px;
                            "
                          :src="items.storeLogo ? items.storeLogo:require('../../assets/storeLogo.jpeg')" alt="">

                          <div class="topServBoxInfo">
                            <h3 :title="items.enterPriseName">{{ items.enterPriseName }}</h3>
                            <p :title="items.detailAddress">{{ items.detailAddress }}</p>
                          </div>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <p
                          style="
                            font-size: 12px;
                            margin-bottom: 8px;
                            color: #000;
                          "
                        >
                          服务数量
                        </p>
                        <p style="color: #0f1826; font-weight: bold">
                          {{ items.serviceCount == null ? 0 : items.serviceCount }}
                        </p>
                      </el-col>
                      <el-col :span="3">
                        <p
                          style="
                            font-size: 12px;
                            margin-bottom: 8px;
                            color: #000;
                          "
                        >
                          材料数量
                        </p>
                        <p style="color: #0f1826; font-weight: bold">
                          {{ items.materialCount== null ? 0 : items.materialCount }}
                        </p>
                      </el-col>
                      <el-col :span="5" style="text-align: center">
                        <el-rate
                          :value="items.valueR"
                          disabled
                          :colors="['#da251d', '#da251d', '#da251d']"
                        >
                        </el-rate>
                        <p style="font-size: 12px; padding-top: 2px">
                          好评率：{{ items.good }}
                        </p>
                      </el-col>
                      <el-col :span="3">
                        <el-button
                          size="small"
                          type="primary"
                          @click="getPrintServiceIndex(items.enterPriseId)"
                          >进入主页
                        </el-button>
                      </el-col>
                    </el-row>
                  </div>
                </li>
                <!-- 10 -->
              </ul>
              <div style="text-align: right"  v-if="compDetailsList.length!=0">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    @prev-click="handleCurrentChange"
                    @next-click="handleCurrentChange"
                    layout="total,prev, pager, next,jumper"
                    :current-page="current"
                    :page-size="pageSize"
                    :total="total" class="pagination">
                </el-pagination>
              </div>
            </section>
          </el-col>
        </el-row>
      </section>
    </div>
  </div>
</template>

<script>
import { getShopperList,getServiceabilityList, getRecommendList,
  getDictionaryItem, getDictionaryGroup } from '../../utils/interface';
import provinceData from "../../utils/provinceData";
export default {
  //   商家列表页
  name: "PrintHot",
  metaInfo: {
    title: '服务商 - 我要打印-3D打印服务-为用户提供定制化、快速报价等一站式3D打印服务-增材云', // set a title
    meta: [{                 // set meta
      name: 'keywords',
      content: '砂型铸造 | 3D激光 | FDM熔融 |  高分子材料 | MJP'
    },
      {                 // set meta
        name: 'description',
        content: '增材云-服务商大厅拥有多家3D打印服务商，为增材制造领域不同行业用户提供定制化、快速报价等一站式3D打印服务。'
      }],
  },
  components: {},
  data() {
    return {
      keywords:[],
      input: "",
      groupCode: "print_banner",
      technologyCode:'server_print',
      parentCode: 'material_print',
      current:1,
      total: 0,
      pageSize: 10,
      materialId:'',
      serviceId:'',
      storeCity:'',
      hotSells: [],
      hotSevers: [],
      compDetailsList: [],
      serveList: [],
      serveList2: [],
      severmessIndex: "0",
      severmessIndex2: "0",
      // 地区选择
      regionValue: "",
      regionOptions: provinceData,
    };
  },
  created(){
    // 服务行业
    this.getItemList();
    // 材料类型
    this.getDictionaryGroup();
    // 服务商列表
    this.getShopperList();
    // 热门服务
    this.getServiceabilityList();
    // 推荐服务商
    this.getRecommendList();
  },
  methods: {
    handleChange(value) {
      if(value != null && value.length == 3){
          this.storeCity = value[0]+","+value[1]+","+value[2];
      } else if(value != null && value.length == 2){
          this.storeCity = value[0]+","+value[1];
      } else if (value.length == 0){
        this.storeCity = value
      }
      this.getShopperList();
    },
    // 分页
    handleCurrentChange(val){
      this.current = val;
	  window.scrollTo(0,0);
      this.getShopperList();
    },
    searchByKeyword(keyword){
      this.input = keyword;
      this.getShopperList();
    },
    getShopperList(){
      let params = {
        serviceId:this.serviceId,
        materialId:this.materialId,
        storeCity:this.storeCity,
        examineStatus:"PASS",
        current:this.current,
        pageSize:this.pageSize,
        isFront:1,
        survival:'ENABLE',
        enterPriseName:this.input
      };
      getShopperList(params).then((res)=>{
        this.compDetailsList = res.list;
        this.total = res.total;
        this.pageSize = res.size;
        this.current = res.current;
      });
    },
    getItemList(){
      let params = {
        groupCode: this.technologyCode,
      };
      getDictionaryItem(params).then((res) => {
        this.serveList = res;
        this.serveList.unshift({uuid:'',name:'全部'});
      });
      getDictionaryItem({groupCode: 'provider_keyword'}).then((res)=>{
        // let re = [];
        if(res != null && res.length > 0){
          res.forEach((item, index) => {
            this.keywords.push(item.name);
          });
        }
      });
    },
    getDictionaryGroup() {
      let params = {
        parentCode: this.parentCode,
      };
      getDictionaryGroup(params).then((res) => {
        this.serveList2 = res;
        this.serveList2.unshift({uuid:'',name:'全部'});
      });
    },
    getServerMess(i,uuid) {
      this.serviceId = uuid;
      this.current = 1;
      this.severmessIndex = i;
      this.getShopperList();
    },
    getServerMess2(i,uuid) {
      this.materialId = uuid;
      this.current = 1;
      this.severmessIndex2 = i;
      this.getShopperList();
    },
    getPrintServiceIndex(enterPriseId) {
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: { enterPriseId:enterPriseId },
      });
      window.open(routeData.href, "_blank");
    },
    getServiceabilityList(){
      let params = {
        current:1,
        pageSize:5
      };
      getServiceabilityList(params).then((res) => {
        this.hotSevers = res.list;
      });
    },
    getServiceDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "printServiceDetails",
        params: { uuid: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    getRecommendList(){
        getRecommendList().then((res) => {
            this.hotSells = res;
        });
    },
  },
};
</script>

<style scoped lang="less">
.printBanner {
  background: url("../../assets/image/fulist.png");
}

.container {
  width: 1200px;
  margin: 0 auto;
}
.desTitle {
  margin-bottom: 15px;
  align-items: center;

  span {
    color: #808080;
    font-size: 14px;
  }
}
.leftCont {
  margin-top: 30px;

  .leftCard {
    margin-bottom: 30px;
    border: none;

    /deep/ .el-card__header {
      color: #157efb;
      background-color: #f3f3f3;
      font-size: 18px;
      padding: 12px 20px;
    }

    /deep/ .el-card__body {
      background-color: #fff;
      padding: 17px;
    }
  }

  .servInfo h3 {
    font-size: 16px;
    font-weight: normal;
    margin-bottom: 15px;
  }

  .servInfo .eval li {
    font-size: 14px;
    margin-bottom: 10px;
    display: flex;
  }

  .servInfo .eval li span {
    margin-right: 30px;
  }

  .servInfo .contact {
    margin-top: 30px;
    margin-bottom: -10px;
    font-size: 12px;
  }

  .servInfo .contact i {
    margin-right: 5px;
  }

  .servInfo .contact p {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.printTitle {
  font-size: 24px;
  font-weight: normal;
  color: #157efb;
  margin-top: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid #e3e3e3;
  padding-bottom: 10px;

  span.tit {
    padding-bottom: 10px;
    border-bottom: 1px solid #157efb;
  }

  span.more {
    font-size: 16px;
    float: right;
    margin-top: 10px;
  }

  .more i {
    color: #505050 !important;
  }
}

.bannerSearch {
  /deep/ .el-input__inner {
    height: 50px;
    line-height: 50px;
  }

  /deep/ .el-input-group__append {
    background-color: #157efb;
    color: #fff !important;
    font-size: 18px;
    border-color: transparent;
  }
}

.hotSell {
  margin-bottom: -30px;
      cursor: pointer;

  li {
    margin-bottom: 30px;
  }

  .topServBoxInfo h3 {
    font-size: 14px;
    margin-bottom: 6px;
    width: 155px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .topServBoxInfo p {
    font-size: 12px;
    color: #aaa;
    width: 155px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /deep/ .el-rate__text {
    font-size: 12px;
    padding-left: 10px;
  }
}

.hotSellServ {
  display: flex;
  align-items: center;

  p {
    font-size: 14px;
    color: #585858;
    text-align: center;
  }

  .topServBoxInfo h3 {
    font-size: 14px;
    margin-bottom: 6px;
    font-weight: normal;
    font-weight: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .topServBoxInfo p {
    font-size: 12px;
    color: #aaa;
    text-align: left;
  }
}

.relateServ {
  margin-bottom: -30px;

  li {
    margin-bottom: 30px;
  }

  .topServBoxInfo h3 {
    font-size: 14px;
    margin-bottom: 6px;
    font-weight: normal;
  }
}

.topServBox {
  background-color: #fff;
  height: 200px;
  border-radius: 8px;
  box-shadow: 0 1px 5px #eaeaea;
  margin-top: -100px;
  padding: 30px;
  box-sizing: border-box;

  .topServBoxInfo h3 {
    font-size: 16px;
    margin-bottom: 6px;
    font-weight: normal;
  }

  .topServBoxInfo p {
    font-size: 12px;
    color: #585858;
  }

  /deep/ .el-menu.el-menu--horizontal {
    border-color: transparent;
  }

  /deep/ .el-menu--horizontal > .el-menu-item.is-active {
    border: none !important;
    background-color: #f3f8ff;
    border-radius: 5px;
  }

  /deep/ .el-menu--horizontal > .el-menu-item {
    height: 30px;
    line-height: 26px;
  }
}

.topServBoxNum {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;

  p:first-child {
    font-size: 16px;
  }

  p:last-child {
    font-size: 12px;
    color: #585858;
  }
}

.menu-sub {
  margin-top: 35px;
  font-size: 16px;
}

.box-card {
  margin-bottom: 30px;
  position: relative;

  .image {
    width: 100%;
    height: 200px;
    display: block;
  }
}

.compInfo p {
  text-indent: 2em;
  font-size: 14px;
  line-height: 1.8;
  color: #808080;
}

.mpBox {
  display: flex;
  align-items: center;
}

.mpCheck {
  position: absolute;
  right: 20px;
  top: 20px;
}

.mpTitle {
  font-size: 16px;
  font-weight: normal;
}

.mpComp {
  margin-top: 10px;
  font-size: 13px;
  color: #000000;
}

.mpPrice {
  margin: 10px 0;
  font-size: 13px;
  color: #da251d;

  span {
    color: #000;
    margin-left: 10px;
  }
}

.mpDetail {
  margin-top: 10px;

  dt {
    float: left;
    width: 70px;
    color: #000;
    font-size: 13px;
    font-weight: normal;
    line-height: 22px !important;
  }

  dd {
    font-size: 13px;
    line-height: 22px !important;
    margin-left: 70px;
    margin-bottom: 5px;
    color: #808080;
  }
}

.mpFooter-v1 {
  text-align: center;
  font-size: 14px;
  background: #f1f5fe;
  border: 1px solid #ebeef5;
  margin: -10px -21px -21px;
  height: 50px;
  line-height: 50px;
}

.mpFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-top: 1px solid #e3e3e3;
  margin: 0 0 -15px;
  position: relative;

  span {
    display: inline-block;
    width: 50%;
    text-align: center;
    font-size: 13px;
    height: 50px;
    line-height: 50px;
  }

  span a {
    font-size: 12px;
    color: #808080;
  }

  span a:hover {
    color: rgba(21, 126, 251, 0.8);
  }

  :after {
    position: absolute;
    content: "";
    width: 1px;
    background-color: #e3e3e3;
    height: 34px;
    top: 8px;
    left: 50%;
  }
}

.printBox {
  /deep/ .el-input--suffix .el-input__inner {
    padding: 0 15px;
  }
}
.clearfix {
  font-size: 16px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

a {
  color: #157efb;
}

a:hover {
  color: rgba(21, 126, 251, 0.8);
}

.mpTime {
  font-size: 12px;
  color: #aaa;
  margin-top: 6px;
}

.screen {
  background-color: #fff;
  // height: 150px;
  font-size: 14px;
  margin-bottom: 30px;

  .screenMess {
    border-bottom: 1px solid #efefef;
    padding: 10px 10px;
    align-items: center;

    .screenMess_t {
      width: 100px;
      text-align: center;
    }

    .screenMess_m {
      cursor: pointer;
      padding: 3px 15px;
      margin-right: 30px;
    }

    .screenMess_m1 {
      cursor: pointer;
      background: #157efb;
      border-radius: 5px;
      color: #fff;
      padding: 3px 15px;
      margin-right: 30px;
    }
  }

  .screenMess2 {
    padding: 10px 10px;

    align-items: center;

    .screenMess_t2 {
      width: 100px;
      text-align: center;
    }

    /deep/ .el-select {
      margin-right: 20px;
      width: 148px;
    }

    /deep/ .el-input__inner {
      /*height: 30px;*/
    }

    /deep/ .el-input__icon {
      line-height: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/print/printHot.vue